import type { Address, Property, PropertyCharacteristics, PropertyCommodity, PropertyDocument, PropertyList, PropertyPrice } from '~/api/gen'
import { propertyNegotiationTypeEnum, propertyTransactionTypeEnum, statePropertyEnum } from '~/api/gen'
import { trackingBrouillon } from '../lifecycle'

const id = '1'

const reference = '999/annonce-test-1'

const address: Address = {
  city: 'Arnac-Pompadour',
  postalCode: '19230',
  street: '14 rue du Bois Vert',
  latitude: 45.40097210120365,
  longitude: 1.376864541404065,
}

const commodities: PropertyCommodity = [
  'SCHOOL',
]

const characteristics: PropertyCharacteristics = {
  habitableArea: 100,
  landArea: 0,
  rooms: 3,
  bedrooms: 2,
  bathrooms: 1,
  toilets: 1,
  floors: 1,
}

const price: PropertyPrice = {
  price: 80000,
  negotiationFees: 500,
  negotiationFeesType: propertyNegotiationTypeEnum.BUYER,
  deedFees: 1000,
  charges: 0,
  netPrice: 80000,
  automaticPrice: true,
}

const photos: PropertyDocument[] = [
  {
    url: 'https://images.unsplash.com/photo-1606074280798-2dabb75ce10c?q=80&w=1935&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  },
]

export const locationAppartementList: PropertyList = {
  id,
  reference,
  miniature: photos[0],
  transactionType: propertyTransactionTypeEnum.RENTAL,
  propertyType: 'APPT',
  propertySubType: 'STUDIO',
  status: statePropertyEnum.ACTIVE,
  trackingStatus: trackingBrouillon,
  price: price.price,
  negotiationFees: price.negotiationFees,
  address,
  habitableArea: characteristics.habitableArea,
  landArea: characteristics.landArea,
  rooms: characteristics.rooms,
  bedrooms: characteristics.bedrooms,
  bathrooms: characteristics.bathrooms,
}

export const locationAppartementDetail: Property = {
  id,
  reference,
  photos,
  transactionType: propertyTransactionTypeEnum.RENTAL,
  propertyType: 'APPT',
  propertySubType: 'DUPLEX',
  propertySizeType: 'T1',
  status: statePropertyEnum.ACTIVE,
  trackingStatus: trackingBrouillon,
  price,
  address,
  commodities,
  complements: {
    complements: ['CELLAR'],
  },
  heatings: {
    heatings: ['ELECTRIC'],
  },
  characteristics,
}
